import { IStandardMultipleAutocomplete } from "../../_common/interface/autocomplete/iStandardMultipleAutocomplete";
import { usersService } from "../../_services/users.service";
import { MultipleAutoComplete } from "./multiple.autocomplete";

interface IMultipleExtAutocomplete extends IStandardMultipleAutocomplete {
}

export const OrganiserMultipleAutoComplete = (params: IMultipleExtAutocomplete) => {

    return (
        <MultipleAutoComplete
            {...params}
            itemsLoader={usersService.getOrganisers}
            label={"Event Organisers"} />
    );
}